import { render, staticRenderFns } from "./AccumulationMain.vue?vue&type=template&id=6f074ee8&"
import script from "./AccumulationMain.vue?vue&type=script&lang=ts&"
export * from "./AccumulationMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports